<template>
  <div class="c-rule">
    <!-- filter -->
    <div class="c-filter">
      <div class="c-form">
        <ElForm label-width="60" inline class="elementui-common-form-styles" v-highlight>
          <ElFormItem label="类型">
            <ElSelect v-model="dropType">
              <ElOption :value="-1" label="不限"></ElOption>
              <ElOption :value="1" label="优质榜"></ElOption>
              <ElOption :value="2" label="潜力榜"></ElOption>
              <ElOption :value="3" label="观察榜"></ElOption>
              <ElOption :value="4" label="危险榜"></ElOption>
            </ElSelect>
          </ElFormItem>

          <ElFormItem class="bg-transparent">
            <ElButton type="primary" @click="addRules">新建规则</ElButton>
            <ElButton type="primary" :loading="uping" @click="upmodel = true">
              <span v-if="!uping">重新生成排行榜</span>
              <span v-else>生成中...</span>
            </ElButton>
          </ElFormItem>
        </ElForm>
      </div>
    </div>

    <!-- table -->
    <div class="c-table-list">
      <rule-table :loading="loading" :data="tableList" :columns="tableCol" @on-refresh="proloadData" @edit-rule="getData" />
      <Page
        show-total
        show-sizer
        show-elevator
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
        class="c-table-page"
      />
    </div>

    <Modal v-model="upmodel" width="400" title="请选择">
      <Form :label-width="110">
        <FormItem label="重新生成时间">
          <DateRangePicker v-model="datetime" :clearable="false" style="width: 220px" :append-to-body="false"></DateRangePicker>
        </FormItem>
      </Form>
      <template slot="footer">
        <Button type="default" @click="upmodel = false">取消</Button>
        <Button type="primary" @click="ok">确定</Button>
      </template>
    </Modal>

    <Modal
      v-model="model"
      width="920"
      class="c-rule-edit"
      :transfer="false"
      :title="title"
      :closable="false"
      :mask-closable="false"
      @on-visible-change="bindGetData"
    >
      <Spin size="large" fix v-if="geting"></Spin>
      <Form :label-width="120">
        <FormItem label="游戏组" prop="group">
          <auto-complete
            :data="groupList"
            :popper-append-to-body="false"
            v-model="group"
            placeholder="全部"
            style="width: 420px"
            @on-select="handleGroup"
          ></auto-complete>
        </FormItem>
        <FormItem label="游戏（多选）" prop="game">
          <el-select v-model="games" :popper-append-to-body="false" multiple filterable style="width: 420px" @change="clear">
            <el-option v-for="item in gamesList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </FormItem>
        <FormItem label="类型">
          <Select v-model="ruleType" style="width: 180px">
            <Option :value="1" label="优质榜"></Option>
            <Option :value="2" label="潜力榜"></Option>
            <!-- <Option :value="3" label="观察榜"></Option> -->
            <Option :value="4" label="危险榜"></Option>
          </Select>
        </FormItem>
        <FormItem label="时间范围">
          <RadioGroup v-model="dateType" type="button">
            <Radio :label="1">日</Radio>
            <Radio :label="2">周</Radio>
            <Radio :label="3">月</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="规则条件">
          <condition v-model="ruleCondition" :data="ruleData" :verify="formErr"></condition>
        </FormItem>
      </Form>

      <template slot="footer">
        <Button type="default" @click="model = false">取消</Button>
        <Button type="primary" :loading="saving" @click="upBillRule">
          <span v-if="!saving">确定</span>
          <span v-else>提交中...</span>
        </Button>
      </template>
    </Modal>
  </div>
</template>
<script>
import moment from 'moment'
import { isArray, isEmpty, timeout } from '@/common/js/utils'
import { getBillRule, updateBillRule, getBillRules, updateBillReportByTime } from '@/api/material.model'
import filterAdds from '../../data/top_filters_add'
import columns from '../../data/top_rule_column'
import RuleTable from './rule-table'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import Condition from '@/components/condition/condition.vue'
import AutoComplete from '@/components/autocomplete/autocomplete'
export default {
  name: 'set-rules',
  components: { RuleTable, DateRangePicker, Condition, AutoComplete },
  props: {
    gamesList: {
      type: Array
    },
    groupList: {
      type: Array
    }
  },
  data() {
    return {
      groupState: null,
      geting: null,
      saving: null,
      uping: null,
      model: null,
      group: '',
      games: [],
      ruleType: 1,
      dateType: 1,
      ruleId: 0,
      ruleCondition: [],

      upmodel: null,
      pageIndex: 1,
      pageSize: 30,
      loading: null,
      total: 0,
      dropType: -1,
      tableCol: [],
      tableList: [],
      datetime: [],
      ruleData: filterAdds,
      formErr: null, // 表单检验状态
      errRes: [] // 错误的数值
    }
  },
  computed: {
    title() {
      return this.ruleId ? '修改规则' : '新建规则'
    }
  },
  methods: {
    addRules() {
      this.ruleId = 0
      this.model = true
    },
    bindGetData() {
      if (!this.ruleId) {
        this.group = ''
        this.games = []
        this.ruleCondition = []
        this.dateType = 1
        this.ruleType = 1
      }
    },
    getData(id) {
      this.ruleId = id
      this.geting = true
      getBillRule({ ruleId: this.ruleId })
        .then((data) => {
          this.geting = false
          if (data) {
            this.ruleType = data.ruleType
            this.dateType = data.dateType
            this.ruleCondition = JSON.parse(data.ruleCondition)
            this.games = data.gameIds.split(',').map((ret) => Number(ret))
            this.model = true
          }
        })
        .catch((err) => {
          this.geting = false
          console.error(err)
        })
    },
    upBillRule() {
      if (!isArray(this.games) || !this.games.length) {
        this.$Message.error('游戏不能为空！')
        return
      }
      if (!isArray(this.ruleCondition) || !this.ruleCondition.length) {
        this.$Message.error('规则条件不能为空！')
        return
      }

      const values = this.ruleCondition.map((rule) => rule.value)
      const emptyIndex = values.findIndex((value) => !value.trim())
      if (emptyIndex > -1) {
        this.$Message.error(`第${emptyIndex + 1}个规则值不能为空！`)
        return
      }

      let params = {
        dateType: this.dateType,
        ruleType: this.ruleType,
        gameIds: this.games.join(','),
        ruleCondition: this.ruleCondition
      }
      if (this.ruleId) params = Object.assign({}, params, { ruleId: this.ruleId })
      this.saving = true
      updateBillRule(params)
        .then((data) => {
          this.saving = false
          if (data) {
            this.model = false
            this.proloadData()
          }
        })
        .catch((err) => {
          this.saving = false
          console.error(err)
        })
    },
    proloadData() {
      this.loading = true
      getBillRules({ page_id: this.pageIndex, page_size: this.pageSize, queryType: this.dropType })
        .then((data) => {
          this.loading = false
          if (data && isArray(data.list) && data.page_info) {
            this.tableList = data.list
            const { total_number } = data.page_info
            this.total = total_number
          }
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error(err)
        })
    },
    ok() {
      const [beginTime, endTime] = this.datetime
      if (!beginTime || !endTime) {
        this.$Message.error('请选择重新生成榜单的时间')
        return
      }
      this.upmodel = false
      this.uping = true
      updateBillReportByTime({ beginTime, endTime })
        .then((data) => {
          this.uping = false
          if (data) {
            this.$Message.success('重新生成榜单成功！')
          }
        })
        .catch((err) => {
          this.uping = false
          console.error(err)
          this.$Message.error('重新生成榜单失败！！')
        })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.proloadData()
    },
    changePageSize(size) {
      this.pageSize = size
      if (this.pageIndex === 1) this.proloadData()
    },

    handleGroup(meta) {
      this.group = meta.id
      if (meta.children) {
        const child = meta.children.map((ret) => parseInt(ret))
        this.games = child.filter((ret) => this.gamesList.map((met) => met.id).includes(ret))
        timeout(800).then(() => {
          this.groupState = true
        })
      }
    },
    clear() {
      if (this.groupState) {
        this.groupState = false
        this.group = ''
      }
    }
  },
  created() {
    const today = moment().format('YYYY-MM-DD')
    this.datetime = [today, today]
    this.tableCol = columns
    this.proloadData()
  },
  watch: {
    dropType() {
      this.pageIndex = 1
      this.proloadData()
    }
  }
}
</script>
<style lang="scss" scoped>
.c-rule {
  height: 100%;
  padding-top: 8px;

  .c-table-list {
    height: calc(100% - 82px);
  }

  .c-table-page {
    padding: 0 8px;
    margin-bottom: 0;
    text-align: right;
  }
}

.c-rule-edit {
  ::v-deep .ivu-modal-body {
    overflow-y: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    max-height: 680px;
  }
}
</style>
